import { render, staticRenderFns } from "./purchaseStorage.vue?vue&type=template&id=2924bbb6&scoped=true&"
import script from "./purchaseStorage.vue?vue&type=script&lang=js&"
export * from "./purchaseStorage.vue?vue&type=script&lang=js&"
import style0 from "./purchaseStorage.vue?vue&type=style&index=0&id=2924bbb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2924bbb6",
  null
  
)

export default component.exports